import { useEffect, useMemo, useState } from 'react'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { ContentLoading } from '../../components/ContentLoading'
import {
  Container,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from 'react-bootstrap'
import { CustomButton } from '../../components/CustomButton'
import {
  ArrowClockwise,
  ClipboardCheck,
  ClipboardCheckFill,
  EyeFill,
  EyeSlashFill,
  FilePdfFill,
  Link45deg,
  PersonAdd,
  PlusCircleFill,
  Search,
} from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { Center } from '../../components/Center'
import { IconButton } from '../../components/IconButton'
import { ModalPessoas } from '../../components/ModalPessoas'
import { formatPrice } from '../../utils/formatPrice'
import { formatDate } from '../../utils/formatDate'
import { Link } from 'react-router-dom'
import { useOrdenation } from '../../hooks/useOrdenation'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

pdfMake.addVirtualFileSystem(pdfFonts)

export function RepresentantesComerciais() {
  const [relations, setRelations] = useState([])
  const [isLoadingRelations, setIsLoadingRelations] = useState(true)
  const [search, setSearch] = useState('')

  const [selectedRepresentante, setSelectedRepresentante] = useState(null)
  const [selectedCliente, setSelectedCliente] = useState(null)

  const [isModalAddOpen, setIsModalAddOpen] = useState(false)

  const [isAddRequest, setIsAddRequest] = useState(false)

  const [searchRepresentante, setSearchRepresentante] = useState('')
  const [searchCliente, setSearchCliente] = useState('')

  const [representantes, setRepresentantes] = useState([])
  const [clientes, setClientes] = useState([])

  const [isLoadingRepresentantes, setIsLoadingRepresentantes] = useState(false)
  const [isLoadingClientes, setIsLoadingClientes] = useState(false)

  const [viewClients, setViewClients] = useState({})
  const [ordersClient, setOrdersClient] = useState({})

  const [isModalRepresentantesOpen, setIsModalRepresentantesOpen] =
    useState(false)
  const [isModalClientesOpen, setIsModalClientesOpen] = useState(false)

  const searchedItems = useMemo(() => {
    return relations.filter((item) =>
      String(item.nome).toLowerCase().includes(String(search).toLowerCase()),
    )
  }, [relations, search])

  const { filteredItems, Th, Paginate } = useOrdenation(
    searchedItems,
    'nome',
    'asc',
  )

  // ─── Paleta de cores ──────────────────────────────────────────────────────────
  const AZUL_PRIMARIO = '#1565C0'
  const AZUL_ESCURO = '#0D47A1'
  const AZUL_CLARO = '#BBDEFB'
  const CINZA_ESCURO = '#37474F'
  const CINZA_LINHA = '#F5F7FA'
  const CINZA_BORDA = '#CFD8DC'
  const BRANCO = '#FFFFFF'

  // ─── Helper ───────────────────────────────────────────────────────────────────
  function dataHoraAtual() {
    return new Date().toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  }
  async function gerarRelatorioRepresentante(relation, clientes) {
    // ── Linhas da tabela de clientes ────────────────────────────────────────────
    const linhasClientes = clientes.map((cliente, i) => [
      {
        text: String(cliente.cliente_id),
        style: 'tbCell',
        alignment: 'center',
        fillColor: i % 2 === 0 ? BRANCO : CINZA_LINHA,
      },
      {
        text: cliente.nome ?? '-',
        style: 'tbCell',
        fillColor: i % 2 === 0 ? BRANCO : CINZA_LINHA,
      },
      {
        text: cliente.cnpj_cpf ?? '-',
        style: 'tbCell',
        alignment: 'center',
        fillColor: i % 2 === 0 ? BRANCO : CINZA_LINHA,
      },
    ])

    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 40, 40, 55],

      // ── Rodapé ────────────────────────────────────────────────────────────────
      footer: (currentPage, pageCount) => ({
        columns: [
          {
            text: `Relatório gerado por ${localStorage.username}.`,
            fontSize: 7,
            color: CINZA_ESCURO,
            margin: [40, 0, 0, 0],
          },
          {
            text: `Página ${currentPage} de ${pageCount}`,
            fontSize: 7,
            color: CINZA_ESCURO,
            alignment: 'right',
            margin: [0, 0, 40, 0],
          },
        ],
        margin: [0, 12, 0, 0],
      }),

      content: [
        // ── Barra superior ────────────────────────────────────────────────────
        {
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 515,
              h: 5,
              color: AZUL_PRIMARIO,
              r: 2,
            },
          ],
          margin: [0, 0, 0, 18],
        },

        // ── Título + data ─────────────────────────────────────────────────────
        {
          columns: [
            {
              stack: [
                {
                  text: 'RELATÓRIO DE',
                  fontSize: 8,
                  bold: true,
                  color: CINZA_ESCURO,
                  characterSpacing: 2,
                },
                {
                  text: 'Representante Comercial',
                  fontSize: 22,
                  bold: true,
                  color: AZUL_ESCURO,
                },
              ],
            },
            {
              stack: [
                {
                  text: 'Emitido em',
                  fontSize: 8,
                  color: CINZA_ESCURO,
                  alignment: 'right',
                },
                {
                  text: dataHoraAtual(),
                  fontSize: 9,
                  bold: true,
                  color: CINZA_ESCURO,
                  alignment: 'right',
                },
              ],
              margin: [0, 6, 0, 0],
            },
          ],
          margin: [0, 0, 0, 22],
        },

        // ── Card do representante ─────────────────────────────────────────────
        {
          table: {
            widths: ['*'],
            body: [
              [
                {
                  fillColor: AZUL_PRIMARIO,
                  border: [false, false, false, false],
                  stack: [
                    {
                      text: 'REPRESENTANTE',
                      fontSize: 7,
                      bold: true,
                      color: AZUL_CLARO,
                      characterSpacing: 1,
                      margin: [0, 0, 0, 8],
                    },
                    {
                      columns: [
                        {
                          width: 70,
                          stack: [
                            { text: 'ID', fontSize: 8, color: AZUL_CLARO },
                            {
                              text: String(relation.representante_id),
                              fontSize: 16,
                              bold: true,
                              color: BRANCO,
                            },
                          ],
                        },
                        {
                          width: '*',
                          stack: [
                            { text: 'Nome', fontSize: 8, color: AZUL_CLARO },
                            {
                              text: relation.nome,
                              fontSize: 13,
                              bold: true,
                              color: BRANCO,
                            },
                          ],
                        },
                        {
                          width: 170,
                          stack: [
                            {
                              text: 'CPF | CNPJ',
                              fontSize: 8,
                              color: AZUL_CLARO,
                            },
                            {
                              text: relation.cnpj_cpf,
                              fontSize: 13,
                              bold: true,
                              color: BRANCO,
                            },
                          ],
                        },
                      ],
                    },
                  ],
                  margin: [18, 14, 18, 16],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: () => 0,
            vLineWidth: () => 0,
          },
          margin: [0, 0, 0, 26],
        },

        // ── Subtítulo clientes ────────────────────────────────────────────────
        {
          columns: [
            {
              canvas: [
                {
                  type: 'rect',
                  x: 0,
                  y: 3,
                  w: 4,
                  h: 15,
                  color: AZUL_PRIMARIO,
                  r: 1,
                },
              ],
              width: 14,
            },
            {
              stack: [
                {
                  text: 'Clientes Vinculados',
                  fontSize: 13,
                  bold: true,
                  color: AZUL_ESCURO,
                },
                {
                  text: `${clientes.length} cliente${clientes.length !== 1 ? 's' : ''} encontrado${clientes.length !== 1 ? 's' : ''}`,
                  fontSize: 9,
                  color: CINZA_ESCURO,
                },
              ],
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // ── Tabela de clientes ────────────────────────────────────────────────
        clientes.length === 0
          ? {
              text: 'Nenhum cliente vinculado a este representante.',
              fontSize: 10,
              color: CINZA_ESCURO,
              italics: true,
              alignment: 'center',
              margin: [0, 20, 0, 0],
            }
          : {
              table: {
                headerRows: 1,
                widths: [60, '*', 150],
                body: [
                  [
                    {
                      text: 'ID',
                      style: 'tbHeader',
                      alignment: 'center',
                      fillColor: AZUL_ESCURO,
                    },
                    {
                      text: 'Nome',
                      style: 'tbHeader',
                      fillColor: AZUL_ESCURO,
                    },
                    {
                      text: 'CPF | CNPJ',
                      style: 'tbHeader',
                      alignment: 'center',
                      fillColor: AZUL_ESCURO,
                    },
                  ],
                  ...linhasClientes,
                ],
              },
              layout: {
                hLineWidth: (i, node) =>
                  i === 0 || i === node.table.body.length ? 0 : 0.5,
                vLineWidth: () => 0,
                hLineColor: () => CINZA_BORDA,
                paddingLeft: () => 10,
                paddingRight: () => 10,
                paddingTop: () => 7,
                paddingBottom: () => 7,
              },
            },

        // ── Linha decorativa inferior ─────────────────────────────────────────
        {
          canvas: [
            { type: 'rect', x: 0, y: 0, w: 515, h: 3, color: AZUL_CLARO, r: 1 },
          ],
          margin: [0, 30, 0, 0],
        },
      ],

      styles: {
        tbHeader: {
          fontSize: 9,
          bold: true,
          color: BRANCO,
          margin: [0, 2, 0, 2],
        },
        tbCell: {
          fontSize: 9,
          color: CINZA_ESCURO,
        },
      },

      defaultStyle: {
        font: 'Roboto',
      },
    }

    pdfMake.createPdf(docDefinition).open()
  }

  async function loadRelations() {
    try {
      setIsLoadingRelations(true)

      const response = await apinode.get(`/rc/${localStorage.idconta}`)

      setRelations(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar as relações')
    } finally {
      setIsLoadingRelations(false)
    }
  }

  async function handleGetOrders(clientId, index) {
    try {
      setOrdersClient((prevState) => ({
        [index]: {
          ...prevState[index],
          isLoading: true,
        },
      }))

      const response = await apinode.get(
        `/rc/clients/${clientId}/orders/${localStorage.idconta}`,
      )

      if (response.data.length === 0) {
        return toast.info('Sem dados disponíveis!')
      }

      setOrdersClient((prevState) => ({
        [index]: {
          ...prevState[index],
          data: response.data,
        },
      }))
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar os pedidos')
    } finally {
      setOrdersClient((prevState) => ({
        [index]: {
          ...prevState[index],
          isLoading: false,
        },
      }))
    }
  }

  async function handleLoadRepresentantes() {
    try {
      setIsLoadingRepresentantes(true)

      const response = await apinode.get(
        `/rc/representantes/${localStorage.idconta}?search=${searchRepresentante}`,
      )

      setRepresentantes(response.data)
      setIsModalRepresentantesOpen(true)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar representantes')
    } finally {
      setIsLoadingRepresentantes(false)
    }
  }

  async function handleLoadClientes() {
    try {
      setIsLoadingClientes(true)

      const response = await apinode.get(
        `/rc/clientes/${localStorage.idconta}?search=${searchCliente}`,
      )

      setClientes(response.data)
      setIsModalClientesOpen(true)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar clientes')
    } finally {
      setIsLoadingClientes(false)
    }
  }

  async function handleViewClients(representanteId, index) {
    try {
      setViewClients((prevState) => ({
        [index]: {
          ...prevState[index],
          isLoading: true,
        },
      }))

      const response = await apinode.get(
        `/rc/clientes/${localStorage.idconta}?representanteId=${representanteId}`,
      )

      if (response.data.length === 0) {
        return toast.info('Sem dados disponíveis!')
      }

      setViewClients((prevState) => ({
        [index]: {
          ...prevState[index],
          data: response.data,
        },
      }))

      return response.data
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar clientes')
    } finally {
      setViewClients((prevState) => ({
        [index]: {
          ...prevState[index],
          isLoading: false,
        },
      }))
    }
  }

  async function handleAddRepresentanteCliente() {
    if (!selectedRepresentante || !selectedCliente) {
      return toast.info(
        'Selecione um representante e um cliente para continuar.',
      )
    }

    try {
      setIsAddRequest(true)

      await apinode.post(`/rc/${localStorage.idconta}`, {
        cod_representante: selectedRepresentante,
        cod_cliente: selectedCliente,
      })

      await loadRelations()

      toast.success('Cliente adicionado ao representante com sucesso!')
      setIsModalAddOpen(false)
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Erro ao adicionar representante comercial ao cliente',
      )
    } finally {
      setSelectedRepresentante(null)
      setSelectedCliente(null)
      setIsAddRequest(false)
      setSearchCliente('')
      setSearchRepresentante('')
    }
  }

  useEffect(() => {
    loadRelations()
  }, [])

  return (
    <>
      <Navbar />

      <Container className="p-4">
        <h1>Representantes Comerciais</h1>

        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: 5,
          }}
        >
          <CustomButton
            title="Novo"
            onClick={() => setIsModalAddOpen(true)}
            noMargin
          >
            <PersonAdd size={20} />
          </CustomButton>

          <CustomButton
            title="Atualizar"
            onClick={() => loadRelations(true)}
            isLoading={isLoadingRelations}
            isLoadingText="Atualizando..."
            noMargin
          >
            <ArrowClockwise size={20} />
          </CustomButton>

          <Form.Control
            placeholder="Nome..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <ContentLoading
          isLoading={isLoadingRelations}
          loadingText="Carregando..."
        >
          {relations.length === 0 ? (
            <Center>
              <p>Nenhuma relação encontrada.</p>
            </Center>
          ) : (
            <>
              <Table
                striped
                bordered
                hover
              >
                <thead>
                  <tr>
                    <Th
                      label="ID"
                      value="representante_id"
                    />
                    <Th
                      label="Nome"
                      value="nome"
                    />
                    <Th
                      label="CPF | CNPJ"
                      value="cnpj_cpf"
                    />

                    <th>Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems.map((relation, index) => {
                    const hasData = viewClients[index]?.data?.length > 0
                    const isSelected = viewClients[index]

                    function clear() {
                      setViewClients({})
                      setOrdersClient({})
                    }

                    return (
                      <>
                        <tr
                          key={relation.representante_id}
                          style={{
                            fontWeight: isSelected ? 'bold' : 'initial',
                          }}
                        >
                          <td>{relation.representante_id}</td>
                          <td>{relation.nome}</td>
                          <td>{relation.cnpj_cpf}</td>
                          <td>
                            <div style={{ display: 'flex', gap: 5 }}>
                              <OverlayTrigger
                                overlay={
                                  <Tooltip>
                                    {isSelected
                                      ? 'Ocultar Clientes'
                                      : 'Mostrar Clientes'}
                                  </Tooltip>
                                }
                              >
                                <IconButton
                                  onClick={() =>
                                    isSelected
                                      ? clear()
                                      : handleViewClients(
                                          relation.representante_id,
                                          index,
                                        )
                                  }
                                  isLoading={viewClients[index]?.isLoading}
                                >
                                  {isSelected ? (
                                    <EyeSlashFill size={16} />
                                  ) : (
                                    <EyeFill size={16} />
                                  )}
                                </IconButton>
                              </OverlayTrigger>

                              <OverlayTrigger
                                overlay={<Tooltip>Gerar Relatório</Tooltip>}
                              >
                                <IconButton
                                  onClick={async () => {
                                    const viewClientsResponse =
                                      await handleViewClients(
                                        relation.representante_id,
                                        index,
                                      )

                                    await gerarRelatorioRepresentante(
                                      relation,
                                      viewClientsResponse ?? [],
                                      index,
                                    )
                                  }}
                                  color="#592E83"
                                >
                                  <FilePdfFill size={16} />
                                </IconButton>
                              </OverlayTrigger>
                            </div>
                          </td>
                        </tr>

                        {hasData && (
                          <tr>
                            <td colSpan={4}>
                              <Table>
                                <thead>
                                  <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>CPF | CNPJ</th>
                                    <th>Ação</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {viewClients[index]?.data.map(
                                    (cliente, clienteIndex) => {
                                      const hasOrders =
                                        ordersClient[clienteIndex]?.data
                                          ?.length > 0

                                      return (
                                        <>
                                          <tr
                                            key={cliente.cliente_id}
                                            style={{
                                              fontWeight: hasOrders
                                                ? 'bold'
                                                : 'initial',
                                            }}
                                          >
                                            <td>{cliente.cliente_id}</td>
                                            <td>{cliente.nome}</td>
                                            <td>{cliente.cnpj_cpf}</td>
                                            <td>
                                              {' '}
                                              <OverlayTrigger
                                                overlay={
                                                  <Tooltip>
                                                    Buscar Pedidos
                                                  </Tooltip>
                                                }
                                              >
                                                <IconButton
                                                  onClick={() =>
                                                    hasOrders
                                                      ? setOrdersClient({})
                                                      : handleGetOrders(
                                                          cliente.cliente_id,
                                                          clienteIndex,
                                                        )
                                                  }
                                                  isLoading={
                                                    ordersClient[clienteIndex]
                                                      ?.isLoading
                                                  }
                                                  color="#DE3C4B"
                                                >
                                                  {hasOrders ? (
                                                    <ClipboardCheckFill
                                                      size={16}
                                                    />
                                                  ) : (
                                                    <ClipboardCheck size={16} />
                                                  )}
                                                </IconButton>
                                              </OverlayTrigger>
                                            </td>
                                          </tr>

                                          {hasOrders && (
                                            <tr>
                                              <td colSpan={4}>
                                                <Table>
                                                  <thead>
                                                    <tr>
                                                      <th> Pedido</th>
                                                      <th> Valor</th>
                                                      <th> Data</th>
                                                      <th> Ação</th>
                                                    </tr>
                                                  </thead>

                                                  <tbody>
                                                    {ordersClient[
                                                      clienteIndex
                                                    ]?.data.map((order) => (
                                                      <tr>
                                                        <td>{order.pedido}</td>
                                                        <td>
                                                          {formatPrice(
                                                            order.valor,
                                                          )}
                                                        </td>
                                                        <td>
                                                          {formatDate(
                                                            order.data,
                                                          )}
                                                        </td>
                                                        <td>
                                                          <Link
                                                            to={`/pedido/editar/${order.pedido}`}
                                                            target="_blank"
                                                          >
                                                            <IconButton color="#426A5A">
                                                              <Link45deg
                                                                size={16}
                                                              />
                                                            </IconButton>
                                                          </Link>
                                                        </td>
                                                      </tr>
                                                    ))}
                                                  </tbody>
                                                </Table>
                                              </td>
                                            </tr>
                                          )}
                                        </>
                                      )
                                    },
                                  )}
                                </tbody>
                              </Table>
                            </td>
                          </tr>
                        )}
                      </>
                    )
                  })}
                </tbody>
              </Table>

              <Paginate />
            </>
          )}
        </ContentLoading>
      </Container>

      {isModalAddOpen && (
        <Modal
          show={isModalAddOpen}
          onHide={() => setIsModalAddOpen(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Adicionar Relação</Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-4">
            <Row>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 5,
                }}
              >
                <Form.Control
                  value={searchRepresentante}
                  onChange={(e) => setSearchRepresentante(e.target.value)}
                  placeholder="Nome do representante..."
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && searchRepresentante) {
                      handleLoadRepresentantes()
                    }
                  }}
                />

                <IconButton
                  disabled={!searchRepresentante}
                  onClick={handleLoadRepresentantes}
                  isLoading={isLoadingRepresentantes}
                >
                  <Search size={20} />
                </IconButton>
              </div>
            </Row>

            <Row className="mt-3">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 5,
                }}
              >
                <Form.Control
                  value={searchCliente}
                  onChange={(e) => setSearchCliente(e.target.value)}
                  placeholder="Nome do cliente..."
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && searchCliente) {
                      handleLoadClientes()
                    }
                  }}
                />

                <IconButton
                  disabled={!searchCliente}
                  onClick={handleLoadClientes}
                  isLoading={isLoadingClientes}
                >
                  <Search size={20} />
                </IconButton>
              </div>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <CustomButton
              title="Adicionar"
              onClick={handleAddRepresentanteCliente}
              isLoading={isAddRequest}
              isLoadingText="Adicionando..."
            >
              <PlusCircleFill size={20} />
            </CustomButton>
          </Modal.Footer>
        </Modal>
      )}

      {isModalRepresentantesOpen && (
        <ModalPessoas
          title="Representantes Comerciais"
          isOpen={isModalRepresentantesOpen}
          onClose={() => setIsModalRepresentantesOpen(false)}
          data={representantes}
          onSelect={(pessoa) => {
            setSearchRepresentante(pessoa.nome)
            setSelectedRepresentante(pessoa.id)
          }}
        />
      )}

      {isModalClientesOpen && (
        <ModalPessoas
          title="Clientes"
          isOpen={isModalClientesOpen}
          onClose={() => setIsModalClientesOpen(false)}
          data={clientes}
          onSelect={(pessoa) => {
            setSearchCliente(pessoa.nome)
            setSelectedCliente(pessoa.id)
          }}
        />
      )}
    </>
  )
}
